import React, { useMemo } from "react";

import { useDateTimeFormat } from "../../hooks/useDateTimeFormat";
import { getEnvironmentalContextSnapshot } from "../../utils/environmentalContextSummary";

export default function EnvironmentalContextCell({
  context,
  t,
  showWeatherDetails = true,
}) {
  const { formatDateTime } = useDateTimeFormat();
  const snapshot = useMemo(
    () =>
      getEnvironmentalContextSnapshot(context, {
        includeWeatherDetails: showWeatherDetails,
      }),
    [context, showWeatherDetails],
  );

  if (!snapshot) {
    return (
      <span className="text-xs text-greyscale-3">
        {t("profilePage.environmentUnavailable", "Unavailable")}
      </span>
    );
  }

  const observationDateTime = formatDateTime(snapshot.observationTimestamp);
  const meta = [
    snapshot.status,
    snapshot.source,
    observationDateTime.date && observationDateTime.time
      ? `${observationDateTime.date} ${observationDateTime.time}`
      : observationDateTime.date || observationDateTime.time || null,
    snapshot.locationGranularity,
  ].filter(Boolean);

  return (
    <div className="flex flex-col gap-1 text-left">
      <span className="text-sm text-typography">
        {snapshot.summary ||
          t("profilePage.environmentContextAvailable", "Context available")}
      </span>
      {snapshot.supplementalSummary ? (
        <span className="text-xs text-greyscale-3">
          {snapshot.supplementalSummary}
        </span>
      ) : null}
      {meta.length ? (
        <span className="text-xs text-greyscale-3">{meta.join(" · ")}</span>
      ) : null}
    </div>
  );
}
